module.exports = __webpack_public_path__ + "media/Delivery-X1-Pro-Video.ba68abb5.mp4";